const BATTLE_TAB_KEY = "wr_battle_tab_id_v1";
const BATTLE_WINDOW_PREFIX = "word-runner-battle:";

function makeTabId(): string {
  const bytes = new Uint8Array(5);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function getBattlePlayerId(
  profileId: string,
  roomCode?: string | null,
  role?: "host" | "join",
): string {
  const code = roomCode?.trim().toUpperCase();
  if (code) {
    const activeKey = `wr_battle_active_${code}`;
    if (!role) {
      const active = safeSessionGet(activeKey);
      if (active) return active;
    }

    if (role) {
      const roleKey = `wr_battle_${role}_${code}`;
      const existing = safeSessionGet(roleKey);
      const id = existing || `${profileId}:${role}:${code}:${makeTabId()}`;
      safeSessionSet(roleKey, id);
      safeSessionSet(activeKey, id);
      return id;
    }
  }

  if (typeof window !== "undefined") {
    const existing = window.name.startsWith(BATTLE_WINDOW_PREFIX)
      ? window.name.slice(BATTLE_WINDOW_PREFIX.length)
      : "";
    const tabId = existing || makeTabId();
    if (!existing) window.name = `${BATTLE_WINDOW_PREFIX}${tabId}`;
    return `${profileId}:${tabId}`;
  }

  try {
    let tabId = sessionStorage.getItem(BATTLE_TAB_KEY);
    if (!tabId) {
      tabId = makeTabId();
      sessionStorage.setItem(BATTLE_TAB_KEY, tabId);
    }
    return `${profileId}:${tabId}`;
  } catch {
    return `${profileId}:${makeTabId()}`;
  }
}

export function baseProfileIdFromBattleId(battleId: string): string {
  return battleId.split(":")[0] || battleId;
}

function safeSessionGet(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSessionSet(key: string, value: string) {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    /* ignore private-mode/session storage failures */
  }
}
